<section class="organization-profile" data-testid="organization-profile-page">
    <p *ngIf="loadError"
       class="organization-profile__error"
       data-testid="organization-profile-load-error">
        {{ loadError }}
    </p>
    <form class="form" [formGroup]="editOrganizationForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
            <div class="form-group">
                <label>Name <small>*</small></label>
                <input type="text" placeholder="Organization Name" formControlName="name"
                       [readonly]="!canEditOrganizationName">
                <div class="error"
                     *ngIf="editOrganizationForm.get('name')?.invalid && editOrganizationForm.get('name')?.touched">
                    <small *ngIf="editOrganizationForm.get('name')?.errors?.['required']">Name is required.</small>
                </div>
            </div>
            <div class="form-group">
                <label>Flat/Building Name <small>*</small></label>
                <input id="flatBuildingName" formControlName="flatBuildingName"
                       placeholder="Flat / Building Name"/>
                <div class="error"
                     *ngIf="editOrganizationForm.get('flatBuildingName')?.invalid && editOrganizationForm.get('flatBuildingName')?.touched">
                    <small *ngIf="editOrganizationForm.get('flatBuildingName')?.errors?.['required']">Flat/Building
                        Name is required.</small>
                </div>
            </div>
            <div class="form-group">
                <label>Locality <small>*</small></label>
                <input type="text" placeholder="Locality" formControlName="locality">
                <div class="error"
                     *ngIf="editOrganizationForm.get('locality')?.invalid && editOrganizationForm.get('locality')?.touched">
                    <small *ngIf="editOrganizationForm.get('locality')?.errors?.['required']">Locality is
                        required.</small>
                </div>
            </div>
            <div class="form-group">
                <label for="pincode">Pincode <small>*</small></label>
                <input type="text" id="pincode" placeholder="PIN Code" formControlName="pincode"
                       (input)="onPincodeChange()">
                <div class="error"
                     *ngIf="editOrganizationForm.get('pincode')?.invalid && editOrganizationForm.get('pincode')?.touched">
                    <small *ngIf="editOrganizationForm.get('pincode')?.errors?.['required']">Pincode is
                        required.</small>
                </div>
            </div>
            <div class="form-group">
                <label for="city">City <small>*</small></label>
                <input id="city" formControlName="city" placeholder="City">
                <div class="error"
                     *ngIf="editOrganizationForm.get('city')?.invalid && editOrganizationForm.get('city')?.touched">
                    <small *ngIf="editOrganizationForm.get('city')?.errors?.['required']">City is required.</small>
                </div>
            </div>
            <div class="form-group">
                <label for="state">State <small>*</small></label>
                <input id="state" formControlName="state" placeholder="State">
                <div class="error"
                     *ngIf="editOrganizationForm.get('state')?.invalid && editOrganizationForm.get('state')?.touched">
                    <small *ngIf="editOrganizationForm.get('state')?.errors?.['required']">State is
                        required.</small>
                </div>
            </div>
            <div class="form-group">
                <label for="landmark">Landmark</label>
                <input id="landmark" formControlName="landmark" placeholder="Landmark">
            </div>
            <div class="form-group">
                <label for="addressType">Address Type <small>*</small></label>
                <select formControlName="addressType" id="addressType">
                    <option *ngFor="let option of addressTypes" [value]="option">{{ option }}</option>
                </select>
                <div class="error"
                     *ngIf="editOrganizationForm.get('addressType')?.invalid && editOrganizationForm.get('addressType')?.touched">
                    <small *ngIf="editOrganizationForm.get('addressType')?.errors?.['required']">Address Type is
                        required.</small>
                </div>
            </div>
            <div class="form-group">
                <label for="timezone">Timezone <small>*</small></label>
                <input type="text" formControlName="timezone" placeholder="Timezone" readonly>
                <div class="error"
                     *ngIf="editOrganizationForm.get('timezone')?.invalid && editOrganizationForm.get('timezone')?.touched">
                    <small *ngIf="editOrganizationForm.get('timezone')?.errors?.['required']">Timezone is
                        required.</small>
                </div>
            </div>
            <div class="form-group" *ngIf="canEditOrganizationName">
                <label for="customer_source">Customer Source</label>
                <select formControlName="customer_source" id="customer_source">
                    <option value="">Select Customer Source</option>
                    <option *ngFor="let option of customerSources" [value]="option[0]">{{ option[1] }}</option>
                </select>
            </div>
            <app-sales-installation-partner-select *ngIf="canEditOrganizationName && showSourcePartnerField"
                                                   mode="form" label="Source Partner" placeholder="Select Source Partner"
                                                   [value]="editOrganizationForm.get('source_sales_installation_partner')?.value"
                                                   [currentLabel]="organizationDetail.source_sales_installation_partner_name || ''"
                                                   (valueChange)="setSourcePartner($event)">
            </app-sales-installation-partner-select>
            <div class="form-group" *ngIf="canEditOrganizationName">
                <label for="installation_by">Installation By</label>
                <select formControlName="installation_by" id="installation_by">
                    <option value="">Select Installation Responsibility</option>
                    <option *ngFor="let option of installationOptions" [value]="option[0]">{{ option[1] }}</option>
                </select>
            </div>
            <app-sales-installation-partner-select *ngIf="canEditOrganizationName && showInstallationPartnerField"
                                                   mode="form" label="Installation Partner"
                                                   placeholder="Select Installation Partner"
                                                   [value]="editOrganizationForm.get('installation_sales_installation_partner')?.value"
                                                   [currentLabel]="organizationDetail.installation_sales_installation_partner_name || ''"
                                                   (valueChange)="setInstallationPartner($event)">
            </app-sales-installation-partner-select>
            <div class="form-group form-group-checkbox">
                <label for="isDefault">disabled</label>
                <div class="check">
                    <input type="checkbox" id="isDefault" formControlName="isDefault"/>
                    <span>Set As Default Address</span>
                </div>
            </div>
        </div>
        <div class="button-row">
            <button class="btn-save" type="submit" [disabled]="!formChanged" data-testid="organization-profile-save">
                <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;"></fa-icon>
                Update
            </button>
            <button class="btn-cancel" type="button" (click)="onCancel()" data-testid="organization-profile-cancel">
                <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
                Cancel
            </button>
        </div>
    </form>
</section>
